import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_20/001.jpg'
import img2 from '../assets/issue_20/002.jpg'
import img3 from '../assets/issue_20/003.jpg'
import img4 from '../assets/issue_20/004.jpg'
import img5 from '../assets/issue_20/005.jpg'
import img6 from '../assets/issue_20/006.jpg'
import img7 from '../assets/issue_20/007.jpg'
import img8 from '../assets/issue_20/008.jpg'
import img9 from '../assets/issue_20/009.jpg'
import img10 from '../assets/issue_20/010.jpg'
import img11 from '../assets/issue_20/011.jpg'
import img12 from '../assets/issue_20/012.jpg'
import img13 from '../assets/issue_20/013.jpg'
import img14 from '../assets/issue_20/014.jpg'
import img15 from '../assets/issue_20/015.jpg'
import img16 from '../assets/issue_20/016.jpg'
import img17 from '../assets/issue_20/017.jpg'
import img18 from '../assets/issue_20/018.jpg'
import img19 from '../assets/issue_20/019.jpg'
import img20 from '../assets/issue_20/020.jpg'
import img21 from '../assets/issue_20/021.jpg'
import img22 from '../assets/issue_20/022.jpg'
import img23 from '../assets/issue_20/023.jpg'
import img24 from '../assets/issue_20/024.jpg'
import img25 from '../assets/issue_20/025.jpg'
import img26 from '../assets/issue_20/026.jpg'
import img27 from '../assets/issue_20/027.jpg'
import img28 from '../assets/issue_20/028.jpg'
import img29 from '../assets/issue_20/029.jpg'
import img30 from '../assets/issue_20/030.jpg'
import img31 from '../assets/issue_20/031.jpg'
import img32 from '../assets/issue_20/032.jpg'
import img33 from '../assets/issue_20/033.jpg'
import img34 from '../assets/issue_20/034.jpg'
import img35 from '../assets/issue_20/035.jpg'
import img36 from '../assets/issue_20/036.jpg'
import img37 from '../assets/issue_20/037.jpg'
import img38 from '../assets/issue_20/038.jpg'
import img39 from '../assets/issue_20/039.jpg'
import img40 from '../assets/issue_20/040.jpg'
import img41 from '../assets/issue_20/041.jpg'
import img42 from '../assets/issue_20/042.jpg'
import img43 from '../assets/issue_20/043.jpg'
import img44 from '../assets/issue_20/044.jpg'
import img45 from '../assets/issue_20/045.jpg'
import img46 from '../assets/issue_20/046.jpg'
import img47 from '../assets/issue_20/047.jpg'
import img48 from '../assets/issue_20/048.jpg'


export default class Mag020 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
         <img src={img24} className="image"></img>
        <img src={img25} className="image"></img>
        <img src={img26} className="image"></img>
        <img src={img27} className="image"></img>
        <img src={img28} className="image"></img>
        <img src={img29} className="image"></img>
        <img src={img30} className="image"></img>
        <img src={img31} className="image"></img>
        <img src={img32} className="image"></img>
        <img src={img33} className="image"></img>
        <img src={img34} className="image"></img>
        <img src={img35} className="image"></img>
        <img src={img36} className="image"></img>
        <img src={img37} className="image"></img>
        <img src={img38} className="image"></img>
        <img src={img39} className="image"></img>
        <img src={img40} className="image"></img>
        <img src={img41} className="image"></img>
        <img src={img42} className="image"></img>
        <img src={img43} className="image"></img>
        <img src={img44} className="image"></img>
        <img src={img45} className="image"></img>
        <img src={img46} className="image"></img>
        <img src={img47} className="image"></img>
        <img src={img48} className="image"></img>
      
      </div>
    )
  }
}
